import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ALL_COUNTRIES} from '../../model/geo/Countries';
import {Country} from '../../model/geo/Country';
import {GlobalRegion, globalRegionToLabel} from '../../model/geo/GlobalRegion';
import {AbstractInputDirective} from '../AbstractInputDirective';

@Component({
  selector: 'digires-country-input',
  templateUrl: './country-input.component.html',
  styleUrls: ['./country-input.component.scss']
})
export class CountryInputComponent extends AbstractInputDirective implements OnChanges {
  private readonly globalRegionOrder = {
    [GlobalRegion.EU]: 1,
    [GlobalRegion.NA]: 2,
    [GlobalRegion.APAC]: 3,
    [GlobalRegion.LATAM]: 4,
    [GlobalRegion.NONE]: 5,
  };

  @Output() onCountryChanged = new EventEmitter<Country>();
  @Input() allCountries: Country[] = ALL_COUNTRIES;

  allGlobalRegions: GlobalRegionData[] = [];
  filteredGlobalRegions: GlobalRegionData[];
  filteredCountries: {[key: string]: Country[]};

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.onAllCountriesChanged();
  }

  private onAllCountriesChanged() {
    this.allGlobalRegions = [];
    const globalRegionMap = new Map<string, GlobalRegionData>();

    for (const country of this.allCountries) {
      const globalRegion = country.globalRegion;
      const globalRegionData = globalRegionMap.get(globalRegion);
      if (globalRegionData) {
        globalRegionData.countries.push(country);
      } else {
        const newGlobalRegionData = {
          globalRegion: globalRegion,
          name: globalRegionToLabel[globalRegion],
          countries: [country],
        };
        globalRegionMap.set(globalRegion, newGlobalRegionData);
        this.allGlobalRegions.push(newGlobalRegionData);
      }
    }

    this.allGlobalRegions.sort((g1, g2) =>
      (this.globalRegionOrder[g1.globalRegion] || 100) - (this.globalRegionOrder[g2.globalRegion] || 100)
    );

    this.filteredGlobalRegions = this.allGlobalRegions;
    this.filteredCountries = {};
    for (const globalRegion of this.allGlobalRegions) {
      this.filteredCountries[globalRegion.globalRegion] = globalRegion.countries;
    }
  }

  onFilterCountries(event: any): void {
    if (event.target.value) {
      const lowerCaseVal: string = (event.target.value).toLowerCase();

      const choices: Country[] = [];
      this.filteredGlobalRegions = [];
      for (const globalRegion of this.allGlobalRegions) {
        const filteredCountries = globalRegion.countries.filter(country => country.name.toLowerCase().includes(lowerCaseVal));
        this.filteredCountries[globalRegion.globalRegion] = filteredCountries;
        if (filteredCountries.length > 0) {
          this.filteredGlobalRegions.push(globalRegion);
          choices.push(...filteredCountries);
        }
      }

      const foundOpt = choices.find(el => el.name.toLowerCase() === lowerCaseVal);
      if (foundOpt) {
        this.onCountrySelected(foundOpt);
      }
    } else {
      this.onCountrySelected(undefined);
    }
  }

  onCountrySelected(value: Country): void {
    this.filteredGlobalRegions = this.allGlobalRegions;
    this.filteredCountries = {};
    for (const globalRegion of this.allGlobalRegions) {
      this.filteredCountries[globalRegion.globalRegion] = globalRegion.countries;
    }
    this.formGroup.patchValue({country: value});
    this.onInputChanged();
  }

  countryToName(country: Country): string {
    return country?.name;
  }

  override onInputChanged(): void {
    super.onInputChanged();
    this.onCountryChanged.emit(this.getValue());
  }

}
interface GlobalRegionData {
  globalRegion: GlobalRegion;
  name: string;
  countries: Country[];
}
